import { FC, Fragment } from "preact/compat";
import { Transition } from "@headlessui/react";
import { useApp } from "~/core/store";
import HistoryTree from "./HistoryTree";
import SidebarNode from "./SidebarNode";
import { SidebarProps } from "./interfaces";
import cn from "classnames";

const Sidebar: FC<SidebarProps> = ({ className, tag }) => {
    const {
        help: {
            tagsTree,
            admin: { isEditorHistory },
        },
    } = useApp();

    return (
        <>
            <Transition
                as={Fragment}
                show={!isEditorHistory.value}
                unmount={false}
                enter="transition duration-200 linear"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition duration-200 linear"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
            >
                <div className={cn("absolute left-0 top-0 w-full", className)}>
                    {tagsTree.value.children.map((child) => (
                        <SidebarNode key={child.tag} node={child} />
                    ))}
                </div>
            </Transition>
            <Transition
                as={Fragment}
                show={isEditorHistory.value}
                enter="transition duration-200 linear"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition duration-200 linear"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
            >
                <div
                    className={cn(
                        "absolute right-0 top-0 w-full bg-white",
                        className,
                    )}
                >
                    {tag && <HistoryTree tag={tag} />}
                </div>
            </Transition>
        </>
    );
};

export default Sidebar;
